// CompareSheet — German. 'Close' and 'Loading…' live in common.de.ts. 'not scored' and the
// ProfileZone evidence sentence are declared below rather than borrowed, so this sheet reads
// German on its own; the values are byte-identical to the other declarations.
import { registerDe } from '../i18n/index.js';

registerDe({
  'The comparison did not answer': 'Der Vergleich hat nicht geantwortet',
  'Pick two organisations in the grid to compare their rasters.':
    'Wählen Sie im Raster zwei Organisationen, um ihre Profile zu vergleichen.',
  'cells differ where both are collected': 'Zellen unterscheiden sich, wo beide Seiten erhoben sind',
  'on one side only': 'nur auf einer Seite erhoben',
  'Only what differs': 'Nur Unterschiede',
  'Show every cell': 'Alle Zellen zeigen',
  'Nothing differs between these two — every cell either matches or is uncollected on both sides.':
    'Zwischen diesen beiden unterscheidet sich nichts — jede Zelle stimmt überein oder ist auf beiden Seiten nicht erhoben.',
  'cells': 'Zellen',
  'Neither side keeps a verbatim passage for this cell.':
    'Keine der beiden Seiten hält eine wörtliche Stelle für diese Zelle fest.',
  'Show the verbatim evidence for this value': 'Den wörtlichen Beleg für diesen Wert zeigen',
  'The evidence names a source but keeps no verbatim passage.':
    'Der Beleg nennt eine Quelle, hält aber keine wörtliche Stelle fest.',
  'not scored': 'nicht bewertet',
}, 'CompareSheet');
